import apiClient from '../client';

export const getOrders = async () => {
  const { data } = await apiClient.get('/orders');
  return data?.content ?? data ?? [];
};

// Backend uses orderNumber (string like "SKT-20240101-ABCD"), not numeric id
export const getOrder = async (orderNumber) => {
  const { data } = await apiClient.get(`/orders/${orderNumber}`);
  return data;
};

// Backend endpoint: POST /checkout/create-order
export const createOrder = async (payload) => {
  const { data } = await apiClient.post('/checkout/create-order', payload);
  return data;
};

// Cancel an order by orderNumber
export const cancelOrder = async (orderNumber) => {
  const { data } = await apiClient.post(`/orders/${orderNumber}/cancel`);
  return data;
};
